import { handleExceldownload, handleResponse, handleError } from "./apiUtils";

const baseUrl = "/api/Report/";

export function getReports(org) {
  return fetch(baseUrl + org, {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(handleResponse)
    .catch(handleError);
}

//Download execl for report
export function getExcelFileStatusReport(org, download) {
  return fetch(baseUrl + org + "?export=" + download, {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "Content-Type/attachment",
    }),
    responseType: "blob",
  })
    .then(handleExceldownload)
    .catch(handleError);
}

export function getPrizeReports(org, year, delivered, undelivered) {
  org = org.toUpperCase();
  const url = `${baseUrl}Prize/${org}/${year}?delivered=${delivered}&notDelivered=${undelivered}`;

  console.log(`[API DEBUG] Fetching: ${url}`);

  return fetch(url, {
    method: "GET",
    headers: new Headers({
      Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(response => handleResponse(response, true))
    .catch(error => {
      console.error("[API ERROR] Fetch request failed:", error);
      return { success: false, status: "FETCH_ERROR", message: "Network error or server unreachable." };
    });
}


//Download excel for prize report
export function getExcelFilePrizeReport(
  org,
  year,
  delivered,
  undelivered,
  download
) {
  return fetch(
    baseUrl +
      "Prize/" +
      org +
      "/" +
      year +
      "?delivered=" +
      delivered +
      "&notDelivered=" +
      undelivered +
      "&export=" +
      download,
    {
      method: "GET",
      headers: new Headers({
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "Content-Type/attachment",
      }),
      responseType: "blob",
    }
  )
    .then(handleExceldownload)
    .catch(handleError);
}

export function getYears() {
  return fetch(baseUrl + "YearsWithData", {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(handleResponse)
    .catch(handleError);
}

//Download execl for cases status
export function getExcelFileCasesStatus(year, download) {
  return fetch(
    baseUrl + "IncidenStausReport?year=" + year + "&export=" + download,
    {
      method: "GET",
      headers: new Headers({
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "Content-Type/attachment",
      }),
      responseType: "blob",
    }
  )
    .then(handleExceldownload)
    .catch(handleError);
}

export function getAccumulatedDataimport(comId, year, month) {
  return fetch(
    baseUrl +
      "AccumulatedDataimport?companyId=" +
      comId +
      "&year=" +
      year +
      "&month=" +
      month,
    {
      method: "GET",
      headers: new Headers({
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "application/json",
      }),
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export function getSupplyingCompanies() {
  return fetch(baseUrl + "SupplyingCompanies", {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(handleResponse)
    .catch(handleError);
}

//Download execl for IBNR data report
export async function getExcelFileIBNRdata(year, month, download) {
  try {
        const response = await fetch(
            baseUrl +
            "IbnrDataReport?year=" +
            year +
            "&month=" +
            month +
            "&export=" +
            download,
            {
                method: "GET",
                headers: new Headers({
                    Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
                }),
                responseType: "blob",
            }
        );
        return handleExceldownload(response);
    } catch (error) {
        return handleError(error);
    }
}

//Download execl for prizeshares
export function getExcelFilePrizeShare(member, year, download) {
  return fetch(
    baseUrl +
      "PrizeShares/" +
      member +
      "?year=" +
      year +
      "&export=" +
      download,
    {
      method: "GET",
      headers: new Headers({
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "Content-Type/attachment",
      }),
      responseType: "blob",
    }
  )
    .then(handleExceldownload)
    .catch(handleError);
}

export function getYffIncidentContacts() {
  return fetch("/api/Notify/GetYffIncidentContacts", {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getYffIncidentContactsExcel() {
  return fetch("/api/Notify/GetYffIncidentContacts?export=true", {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "Content-Type/attachment",
    }),
    responseType: "blob",
  })
    .then(handleExceldownload)
    .catch(handleError);
}

export function getNavExtract() {
  return fetch("/api/Notify/GetNavExtract?export=true", {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "Content-Type/attachment",
    }),
    responseType: "blob",
  })
    .then(handleExceldownload)
    .catch(handleError);
}

export function getYffEconomyContacts() {
  return fetch("/api/Notify/GetYffEconomyContacts", {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getYffEconomyContactsExcel() {
  return fetch("/api/Notify/GetYffEconomyContacts?export=true", {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "Content-Type/attachment",
    }),
    responseType: "blob",
  })
    .then(handleExceldownload)
    .catch(handleError);
}
